const ufeApi = require('services/api/ufeApi');
const cookieUtils = require('utils/Cookies');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+SKU+Detail+API

function getReverseLookUpSkuDetails(skuId) {
    let url = `/api/catalog/skus/${skuId}`;

    if (cookieUtils.isPXSEnabled()) {
        url = '/api/v3/catalog/skus/' + skuId;
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getReverseLookUpSkuDetails;
